// extracted by mini-css-extract-plugin
export default {"divi":"MediumComparison_divi__jaOWb","bef":"MediumComparison_bef__qYYsC","aft":"MediumComparison_aft__PUnPD"};